import { P2GBox, P2GButton, P2GGrid, P2GSticky, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  onSave?: () => void;
  onCancel?: () => void;
  saveDisabled?: boolean;
  cancelDisabled?: boolean;
  saveText?: string;
  cancelText?: string;
  centralise?: boolean;
}

interface panelButtonProps {
  onClick?: () => void;
  text: string;
  disabled?: boolean;
  colour?: 'primary' | 'secondary' | 'tertiary';
}

export const PanelButton: React.FC<panelButtonProps> = (props) => {
  const isXs = useP2GMediaQueryOnly('xs');
  return (
    <P2GGrid container gap={1} justify={isXs ? 'center' : 'flex-start'} wrap="nowrap">
      <P2GGrid item xs={6}>
        <P2GButton
          disabled={props.disabled}
          variant={props.colour || 'primary'}
          fullWidth={isXs}
          onClick={props.onClick}
        >
          {props.text}
        </P2GButton>
      </P2GGrid>
    </P2GGrid>
  );
};

export const PanelButtons: React.FC<props> = (props) => {
  const isXs = useP2GMediaQueryOnly('xs');
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  if (!props.onCancel && !props.onSave) {
    return null;
  }

  if (isXs) {
    return (
      <P2GSticky align="bottom">
        <P2GBox pt={1}>
          <P2GGrid container gap={1} justify={'center'} wrap="nowrap">
            {props.onSave && (
              <P2GGrid item xs={6}>
                <P2GButton disabled={props.saveDisabled} variant="primary" fullWidth onClick={props.onSave}>
                  {props.saveText || t('SAVE_BUTTON', { defaultValue: 'Save' })}
                </P2GButton>
              </P2GGrid>
            )}
            {props.onCancel && (
              <P2GGrid item xs={6}>
                <P2GButton disabled={props.cancelDisabled} variant="tertiary" fullWidth onClick={props.onCancel}>
                  {props.cancelText || t('CLOSE_BUTTON', { defaultValue: 'Close' })}
                </P2GButton>
              </P2GGrid>
            )}
          </P2GGrid>
        </P2GBox>
      </P2GSticky>
    );
  }

  return (
    <P2GSticky align="bottom">
      <P2GBox pt={1}>
        <P2GGrid container gap={1} wrap="nowrap" justify={props.centralise ? 'center' : 'flex-start'}>
          {props.onSave && (
            <P2GGrid item>
              <P2GButton disabled={props.saveDisabled} variant="primary" onClick={props.onSave}>
                {props.saveText || t('SAVE_BUTTON', { defaultValue: 'Save' })}
              </P2GButton>
            </P2GGrid>
          )}
          {props.onCancel && (
            <P2GGrid item>
              <P2GButton disabled={props.cancelDisabled} variant="tertiary" onClick={props.onCancel}>
                {props.cancelText || t('CLOSE_BUTTON', { defaultValue: 'Close' })}
              </P2GButton>
            </P2GGrid>
          )}
        </P2GGrid>
      </P2GBox>
    </P2GSticky>
  );
};
